"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const plugins_1 = require("./plugins");
const await_class_1 = require("@src/app/xs/controllers/await.class");
const Cesium = window.Cesium;
class BasemapController extends plugins_1.FdmPlugin {
    constructor() {
        super(...arguments);
        this.controls = {
            provider: { type: 'select', value: null, translateOptions: true, options: [] },
            url: { type: 'url', value: '', noshow: true },
            accessToken: { type: 'text', value: '', noshow: true },
            layers: { type: 'text', value: '', noshow: true },
            assetId: { type: 'text', value: '', noshow: true },
            server: { type: 'url', value: '', noshow: true },
            username: { type: 'text', value: '', noshow: true },
            mapId: { type: 'text', value: '', noshow: true },
            mapStyle: { type: 'text', value: '', noshow: true },
            styleId: { type: 'text', value: '', noshow: true },
            key: { type: 'text', value: '', noshow: true },
            activate: { type: 'button', action: 'activate', noshow: true },
        };
        // labels of all providers
        this.providerLabels = null;
        // current provider (duh)
        this.currentProvider = null;
        // our various supported providers
        this.mapProviders = {
            DefaultImageryProvider: {
                _type: 'MapboxImageryProvider',
                accessToken: 'pk.eyJ1IjoiZ2VvbWF0aWNzIiwiYSI6IjRDSmd3UWcifQ.YEoSImxSElTq1uPwjZnrNw',
                url: 'https://api.mapbox.com/v4',
                mapId: 'mapbox.satellite',
                maximumLevel: 16,
            },
            GeospaceImageryProvider: {
                _type: 'UrlTemplateImageryProvider',
                _authenticationUrl: 'https://cds.geospace.jp/auth/Validate/{$username}/{$accessToken}/',
                _url: 'http://cds.geospace.jp/images/bing/{$mapStyle}/{z}/{x}/{y}?key={_authenticationKey}',
                url: 'http://cds.geospace.jp',
                mapStyle: 'aerial',
                // type:'select',
                _options: ['road', 'aerial', 'satellite', 'hybrid'],
                username: '',
                accessToken: '',
            },
            ArcGisMapServerImageryProvider: { token: false, layers: false, url: true },
            BingMapsImageryProvider: { key: '', url: '', mapStyle: '' },
            IonImageryProvider: { accessToken: '', assetId: '', server: '' },
            GoogleEarthEnterpriseImageryProvider: { url: '' },
            MapboxImageryProvider: { accessToken: '', username: '', mapId: '', url: '' },
            MapboxStyleImageryProvider: { accessToken: '', username: '', styleId: '', url: '' },
            OpenStreetMapImageryProvider: {},
            UrlTemplateImageryProvider: { url: '' },
        };
        this.isJapan = false;
        this.isAuthenticated = false;
        this.authenticationKey = null;
    }
    itemInjected() {
        let team = this.services.fourD && this.services.fourD.activeTeam;
        if (team) {
            let hostname = team['hostname'] ? team['hostname'] : 'other';
            this.isJapan = hostname.indexOf('link') !== -1 ? true : false;
        }
        // for Japan dev; remove before checking in
        // this.isJapan = true;
        if (!this.isJapan) {
            delete this.mapProviders.GeospaceImageryProvider;
            // https://cds.geospace.jp/auth/Validate/nttwkyousou_trial/XNaJBDA1KLVPeLcCke2CH5tqOYaYjWDS/
            // console.log('## basemap isJapan', this.mapProviders );
        }
        // this.firstTimeControls = this.controls;
        // console.log('====== CONSTRUCT ======= PRE', this, this.firstTimeControls, this.controls );
        await_class_1.XsAwait.until('services.mapService.viewer.scene', this).then((_) => {
            const viewer = this.services.mapService.viewer;
            let layers = viewer.imageryLayers;
            layers.layerAdded.addEventListener(function (layer) {
                // console.log('====== LAYERS ADDED', layer );
            });
            layers.layerRemoved.addEventListener(function (layer) {
                // console.log('====== LAYERS REMOVED', layer );
            });
            let options = [];
            // console.log('====== CONSTRUCT ======= START', this.mapProviders, this.firstTimeControls );
            Object.keys(this.mapProviders).forEach((key) => {
                // this.mapProviders[key] = _.clone(this.mapGenericConfig);
                if (!this.mapProviders[key]._type) {
                    this.mapProviders[key]._type = key;
                }
                if (!this.mapProviders[key]._instance) {
                    this.mapProviders[key]._instance = null;
                }
                if (!this.mapProviders[key]._fields) {
                    this.mapProviders[key]._fields = Object.keys(this.mapProviders[key]).filter((k) => k.indexOf('_') !== 0);
                    this.mapProviders[key]._fieldsSchema = {};
                    Object.keys(this.mapProviders[key]._fields).forEach((k) => {
                        if (this.mapProviders[key].hasOwnProperty(k)) {
                            this.mapProviders[key]._fieldsSchema[k] = typeof this.mapProviders[key][k];
                        }
                    });
                    // console.log('====== CONSTRUCT ======= FIELDS', this.mapProviders[key]._fieldsSchema );
                }
                this.mapProviders[key]._label = key.substr(0, key.indexOf('ImageryProvider'));
                // console.log('====== CONSTRUCT ======= LABEL', this.mapProviders[key]._label );
                options.push(this.mapProviders[key]._label);
            });
            this.providerLabels = options;
            // console.log('====== CONSTRUCT ======= END', options, this.mapProviders );
            this.createControls(null);
            this.activate(false);
        });
    }
    hideAll() {
        this.turnOffAllBut('activate');
        this.turnOn(['provider', 'activate']);
    }
    createControls(key = 'Default') {
        let hideMode = false;
        if (!key) {
            key = this.controls.provider.value;
        }
        else if (key == 'Default') {
            hideMode = true;
        }
        this.currentProvider = key;
        this.isAuthenticated = false;
        this.authenticationKey = null;
        const lutkey = key + 'ImageryProvider';
        // console.log('@@@@@CONTROLS START', lutkey, this.mapProviders, this.mapProviders[lutkey] );
        this.controls.provider.value = key;
        this.controls.provider.options = this.providerLabels; // { type:'select', value:key, translateOptions:false, options: this.providerLabels, name:this.meta.translator+'.PROVIDER',  } ; // _.clone(this.controlsTemplate);
        this.hideAll();
        if (this.mapProviders[lutkey] && this.mapProviders[lutkey]._fields) {
            this.turnOn(this.mapProviders[lutkey]._fields);
            this.mapProviders[lutkey]._fields.forEach((k) => {
                // Only replace values if the mapProvider has defaultl values, otherwise leave the ones in the controller as they may come from the DB (stored on the scene/TransformGroup)
                if (this.controls[k] && this.mapProviders[lutkey][k]) {
                    // console.log('@@@@@CONTROLS P', k, this.mapProviders[lutkey][k] );
                    this.controls[k].value = this.mapProviders[lutkey][k];
                    if (key == 'Default') {
                        this.turnOff([k]);
                    }
                }
                else {
                    // console.log('@@@@@CONTROLS xxx', k, this.mapProviders[lutkey][k] );
                }
            });
        }
        if (key == 'Geospace') {
            console.log('## basemap CTRL Geospace');
            // this.turnOff(['url']);
        }
        // console.log('@@@@@CONTROLS END', lutkey, this.mapProviders[lutkey] );
    }
    refresh(newvalue = null, section = null) {
        let me = this;
        // check in with mama
        super.refresh(newvalue, section);
        if (this.controls.provider) {
            if (this.controls.provider.value !== this.currentProvider) {
                this.createControls(this.controls.provider.value);
            }
        }
    }
    urlTemplateConfig(url, selected = null) {
        // first, push in any fields and their values (if any selected provider comes in)
        if (selected) {
            selected._fields.forEach((field) => {
                const token = '{$' + field + '}';
                const value = this.controls[field].value;
                url = url.replace(token, value);
                // console.log('## basemap __', field, token, '"'+value+'"' );
            });
        }
        // then any plugin properties we commonly know
        ['authenticationKey'].forEach((field) => {
            const token = '{_' + field + '}';
            const value = this[field];
            url = url.replace(token, value);
            // console.log('## basemap ___', field, token, '"'+value+'"' );
        });
        return url;
    }
    authenticateCheck() {
        let lutkey = this.controls.provider.value + 'ImageryProvider';
        const selected = this.mapProviders[lutkey];
        return new Promise((resolve) => {
            if (selected && selected._authenticationUrl) {
                // yes, we need to manually authenticate user first
                let url = this.urlTemplateConfig(selected._authenticationUrl, selected);
                let modded_url = 'https://dev.correllink.com/proxy/proxy/' + url.replace('https://cds.', '');
                modded_url = modded_url.replace('.jp', '_jp');
                // console.log('## basemap NEEDS AUTH', url, selected );
                fetch(modded_url)
                    .then((result) => {
                    result.json().then((data) => {
                        if (data && data['authorizeKey']) {
                            this.authenticationKey = data['authorizeKey'];
                        }
                        console.log('## basemap AUTH JSON', data);
                        resolve(result.ok);
                    });
                })
                    .catch((error) => {
                    console.log('## basemap AUTH ERROR', error);
                    resolve(false);
                });
            }
            else {
                // doesn't need manual authentication; the driver probably handles all that
                resolve(true);
            }
        });
    }
    activate(alsoSave = true, forceKey = null) {
        this.authenticateCheck().then((ok) => {
            console.log('## basemap AUTH', ok);
            if (!ok) {
                console.error('## basemap authentication FAILED');
                return;
            }
            const viewer = this.services.mapService.viewer;
            let layers = viewer.imageryLayers;
            let baseLayer = layers.get(0);
            this.firstTimeControls = null;
            let lutkey = this.controls.provider.value + 'ImageryProvider';
            if (forceKey) {
                lutkey = forceKey + 'ImageryProvider';
                this.createControls(forceKey);
            }
            const selected = this.mapProviders[lutkey];
            let config = null;
            let r = null;
            // console.log('@@@@@ACTIVATE', lutkey, selected, baseLayer );
            if (selected) {
                // console.log('@@@@@ACTIVATE SELECTED', Object.keys(selected), baseLayer );
                if (baseLayer) {
                    // console.log('@@@@@ACTIVATE REMOVE_BASE', baseLayer, layers );
                    layers.remove(baseLayer, true);
                    // console.log('@@@@@ACTIVATE REMOVE_BASE END', layers );
                }
                selected._instance = null;
                if (!selected._instance) {
                    // console.log('@@@@@ACTIVATE NO INSTANCE' );
                    selected._fields.forEach((k) => {
                        if (!config) {
                            config = {};
                        }
                        if (this.controls[k] && this.controls[k].value !== null && ('' + this.controls[k].value).trim() !== '') {
                            config[k] = this.controls[k].value;
                        }
                    });
                    if (config) {
                        // are we using a template?
                        if (selected._url) {
                            config.url = this.urlTemplateConfig(selected._url, selected);
                            console.log('@@@@@ACTIVATE USING TEMPLATE', selected._url, config.url);
                        }
                        selected._instance = new Cesium[selected._type](config);
                    }
                    else {
                        selected._instance = new Cesium[selected._type]();
                    }
                    // console.log('@@@@@ACTIVATE NEW INSTANCE', config, selected );
                    // console.log('@@@@@ACTIVATE NEW INSTANCE2', Object.keys(selected._fields) );
                }
                else {
                    // console.log('@@@@@ACTIVATE OLD INSTANCE', config, selected._instance );
                }
                r = layers.addImageryProvider(selected._instance, 0);
                let credit = selected._instance._credit ? selected._instance._credit['_html'] : selected._instance._credit;
                let url = selected._instance._resource ? selected._instance._resource['_url'] : selected._instance._resource;
                if (credit) {
                    this.item['creditBy'] = credit;
                }
                // console.log('@@@@@ACTIVATE SELECTED', selected._instance, r, credit, url );
            }
            // console.log('@@@@@ACTIVATE LUT', lutkey, selected, r );
            // layers.add
            layers = viewer.imageryLayers;
            // console.log('@@@@@ACTIVATE', config, this.controls, selected );
            if (alsoSave) {
                // console.log('@@@@@ACTIVATE SAVE', config, selected._instance );
                this.save();
            }
        });
    }
    end() {
        // console.log('@@@@@BASEMAP END IS NEAR' );
        // end means, return to default settings
        this.controls.provider.value = 'Default';
        this.activate(false, 'Default');
        // console.log('@@@@@BASEMAP ENDING ...' );
    }
    authenticateURL(url) { }
}
// required name identifier
BasemapController.meta = {
    label: 'PLUGINS.BASEMAP_CONTROLLER.LABEL',
    name: 'basemap-controller',
    translator: 'PLUGINS.BASEMAP_CONTROLLER',
    tooltip: 'PLUGINS.BASEMAP_CONTROLLER.TOOLTIP',
    shortcut: true,
    icon: 'map',
    category: plugins_1.FdmPlugin.category.generic,
    types: [plugins_1.FdmPlugin.types.basemapController],
    cardinality: plugins_1.FdmPlugin.cardinality.one,
};
exports.BasemapController = BasemapController;
